
import { mdiClose } from "@mdi/js";
import IconNoteEye from "~/components/v2/icons/IconNoteEye.vue";
import IconQuastion from "~/components/v2/icons/IconQuastion.vue";

export default {
  components: {
    IconQuastion,
    IconNoteEye,
  },
  props: {
    profileId: {
      type: Number,
      required: true,
    },
    feedbackType: {
      type: String,
      required: true,
    },
    isNewReview: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      mdiClose,
      isOpen: false,
      loading: false,
      isRecaptchaValid: true,

      form: {
        profile_id: this.profileId,
        subject: "",
        text: "",
      },
    };
  },

  computed: {
    titleIcon() {
      return this.isReview ? IconNoteEye : IconQuastion;
    },

    isReview() {
      return this.feedbackType === "reviews";
    },

    modalHeaderText() {
      return this.isReview
        ? this.$t("write-a-review")
        : this.$t("ask-a-question");
    },

    succesMessage() {
      return this.isReview
        ? this.$t("success-your-review-has-been-shown-after-moderation")
        : this.$t("your-comment-has-been-added");
    },

    dialogProps() {
      const classes =
        "review-comment-modal__dialog" +
        (this.isReview ? " review-comment-modal__dialog--review" : "");
      if (
        this.$device.isMobile ||
        (typeof window !== "undefined" && window.innerWidth < 993)
      ) {
        return {
          scrollable: true,
          transition: "dialog-bottom-transition",
          contentClass: classes,
        };
      } else {
        return {
          maxWidth: 860,
          transition: "dialog-transition",
          contentClass: classes,
        };
      }
    },
  },

  methods: {
    open() {
      this.isOpen = true;
    },

    close() {
      this.isOpen = false;
      this.clearForm();
    },

    onCaptchaError() {
      this.isRecaptchaValid = false;
    },

    onCaptchaSuccess() {
      this.isRecaptchaValid = true;
    },

    onCaptchaExpired() {
      this.isRecaptchaValid = false;
    },

    clearForm() {
      this.form.subject = "";
      this.form.text = "";
      this.isRecaptchaValid = true;
      this.$refs.form.resetValidation();
    },

    async submit() {
      try {
        if (this.$refs.form.validate()) {
          this.loading = true;
          let token = null;
          if (!this.isReview) {
            token = await this.$recaptcha.getResponse();
          }
          this.isRecaptchaValid = !!token;

          await this.$axios.post(`/api/${this.feedbackType}/add`, {
            ...this.form,
            "g-recaptcha-response": token,
          });

          this.close();

          this.$notify({
            type: "success",
            message: this.succesMessage,
          });
        }
      } catch (error) {
        if (error == "Failed to execute") {
          this.isRecaptchaValid = false;
        }
        this.$notify({
          message: this.$t("something-went-wrong"),
          type: "error",
        });
        return;
      } finally {
        this.loading = false;
      }
    },
  },
};
